import {JsonProperty} from '@hyperloris/tyson';
import {TableSort} from "./table-sort";
import {TableFilter} from "./table-filter";
import {SyncMetadata} from "./sync-metadata";
import {FilterMetadata, LazyLoadEvent} from "primeng/api";

export class TableRequest {
  @JsonProperty()
  originEvent?: LazyLoadEvent;
  @JsonProperty()
  first?: number;
  @JsonProperty()
  rows?: number;
  @JsonProperty()
  sortField?: string;
  @JsonProperty()
  sortOrder?: number;
  @JsonProperty()
  multiSortMeta?: TableSort[];
  @JsonProperty()
  filters?: TableFilter[] = [];
  @JsonProperty()
  filters2?: TableFilter[] = [];
  @JsonProperty()
  filters3?: TableFilter[] = [];
  @JsonProperty()
  globalFilter?: string = '';
  @JsonProperty()
  syncMetadata?: SyncMetadata

  @JsonProperty()
  forceDatasetReload?: boolean;
  @JsonProperty()
  disableSyncMetadataCache?: boolean;

  tabId?: string;
  wsViewId?: string;
  requestId?: string;

  constructor(event: LazyLoadEvent = undefined) {
    if (event) {
      // console.log("-------> event "+JSON.stringify(event))
      this.originEvent = JSON.parse(JSON.stringify(event));
      //...event};
      // if (this.originEvent.filters) {
      //   this.originEvent.filters = JSON.parse(JSON.stringify(this.originEvent.filters));//{...this.originEvent.filters};
      //   // // const newEventFilter = {};
      //   // for (let key in this.originEvent.filters) {
      //   //   // console.log("-----> key "+key)
      //   //   if (this.originEvent.filters[key].value && this.originEvent.filters[key].value != null) {
      //   //     this.originEvent.filters[key] = {...this.originEvent.filters[key]};
      //   //     // newEventFilter[key] = {...this.originEvent.filters[key]};
      //   //   }
      //   // }
      //   // this.originEvent.filters = newEventFilter;
      // }
      // if (this.originEvent.multiSortMeta) {
      //   this.originEvent.multiSortMeta = JSON.parse(JSON.stringify(this.originEvent.multiSortMeta)); [...this.originEvent.multiSortMeta];
      //   for (let key in this.originEvent.multiSortMeta) {
      //     this.originEvent.multiSortMeta[key] = {...this.originEvent.multiSortMeta[key]};
      //   }
      // }
      this.first = event.first;
      this.rows = event.rows;
      this.sortField = event.sortField;
      this.sortOrder = event.sortOrder;
      this.globalFilter = event.globalFilter;
      if (!this.globalFilter) this.globalFilter = undefined;
      this.filters.push(...TableRequest.extractTableEventFilters(event));
      this.multiSortMeta = event.multiSortMeta;
    }
  }

  public static extractTableEventFilters(event: LazyLoadEvent) {
    const filters: TableFilter[] = [];
    for (let filtersKey in event.filters) {
      // if (filtersKey !== 'global') {
      let position: number = 0;
      while (event.filters[filtersKey][position]) {
        // if (event.filters[filtersKey][position].value != null) {
        let filter = new TableFilter();
        filter.field = filtersKey;
        filter.matchMode = event.filters[filtersKey][position].matchMode;
        filter.operator = event.filters[filtersKey][position].operator;
        filter.value = event.filters[filtersKey][position].value;
        if (filter.value)
          filters.push(filter);
        position++;
      }
    }
    // }
    return filters;
  }
}

